module.exports = __webpack_public_path__ + "img/horizontal_6_1_3.e7d5adeb.png";